// extracted by mini-css-extract-plugin
module.exports = {"storeNameWrapper":"style_storeNameWrapper__3yxZn","detailsLink":"style_detailsLink__1cC8Q"};